/* Copyright (c) 2016-2023 Planticle Pty Ltd */

import ko from "knockout";
import birdata from "../../../api.js";
import SortableTableViewModel from "../../shared/sortable-table.js";
import { loader } from "../../../util/ko-util.js";

function ManageSharedSitesHomeViewModel(params) {
	var self = this;

	self.layerLoader = loader(() => birdata.sharedSiteLayers({ can_manage: true }));
	self.layers = self.layerLoader.value;

	self.tableParams = {
		tableClass: 'compact row-clickable',
		items: self.layers,
		rowClick: function(layer, evt) {
			params.parent.editLayer(layer.id);
		},
		columns: [{
			name: 'Layer Name',
			sortable: true,
			value: function(layer) { return layer.name; },
			id: 'name'
		}, {
			name: 'Used by Program(s)',
			sortable: true,
			value: (layer) => layer.programs.map(p => p.name),
			id: 'programs'
		}, {
			name: 'Sites',
			sortable: true,
			value: (layer) => layer.site_count,
			formatted: (layer) => layer.site_count.toLocaleString(),
			id: 'site_count',
			style: {
				width: '6em',
				textAlign: 'right'
			}
		}],
		sortDescriptors: [{
			column: "name",
			ascending: "true"
		}],
		emptyMessage: "No shared site layers to show."
	};
}


ko.components.register('manage-shared-sites-home', {
	viewModel: function(params) {
		return new ManageSharedSitesHomeViewModel(params);
	},
	template: require('../../../../templates/admin/shared-sites/manage-shared-sites-home.html')
});
